import { BlocksLayoutSection } from 'blocks-nextjs/blocks-web-components/components/layout-section/layout-section';
import React from 'react';
import { createComponent } from '../CustomWrapper/CustomWrapper';

export const CatLayoutSection = createComponent({ react: React, tagName: 'cat-layout-section', elementClass: BlocksLayoutSection });
